export function matchByDomain(items, hostname) {
  const normalizedHostname = hostname.toLowerCase();
  return items.find(item => item.domain != null && item.domain.toLowerCase() === normalizedHostname);
}